/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const close = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 1000 1000", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("path", { fill: "currentColor", d: "M921 0L500 421 79 0 0 79l421 421L0 921l79 79 421-421 421 421 79-79-421-421 421-421-79-79z" })));
close.displayName = 'close';
export default close;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=close.js.map